import React, { FunctionComponent, useCallback } from "react";
import { Dialog, Grid } from "@mui/material";
import CalculatorModal from "../Shared/CalculatorModal";
import { useToast } from "contexts/ToastContext";
import styles from "../Styles/loginPageStyle.module.css";
import EstimatedProductionTimesFormSections from "./EstimatedProductionTimesFormSections";
import {
  EstimatedProductionTimesType,
  ProductVMType,
} from "types/products/ProductCommandsType";

type PropsType = {
  product: ProductVMType;
  quantity: number;
  isOpen: boolean;
  onSave: (times: EstimatedProductionTimesType) => void;
  onClose: (open: boolean) => void;
};

const EstimatedProductionTimesDialog: FunctionComponent<PropsType> = ({
  product,
  quantity,
  isOpen,
  onSave,
  onClose,
}) => {
  const { addToast } = useToast();

  //hack for deep cloning
  const timesClone = product.estimatedProductionTime
    ? JSON.parse(JSON.stringify(product.estimatedProductionTime))
    : null;

  const [times, setTimes] = React.useState(timesClone);

  let handleTimesChange = useCallback(
    (times: any) => {
      setTimes(times);
    },
    [setTimes],
  );

  const handleDialogClose = () => {
    onClose(false);
    addToast({
      type: "warning",
      message: (
        <>
          Estimated production time was <strong>not set</strong>.
        </>
      ),
    });
  };

  const handleSave = () => {
    onSave(times);
    onClose(false);
    addToast({
      type: "info",
      message: (
        <>
          <strong>Saving</strong> estimated production times...
        </>
      ),
    });
  };

  return (
    <>
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              maxWidth: "1050px",
            },
          },
        }}
        open={isOpen}
        onClose={() => onClose(false)}
      >
        <h4 className={styles.calcBoldTitle}>
          {"Sales Estimate for Production Time"}
        </h4>
        <div className={styles.pd2}>
          <Grid item direction={"row"} sx={{ display: "flex" }}>
            <Grid item xs={8} style={{ width: "450px" }}>
              <EstimatedProductionTimesFormSections
                times={times}
                totalMultiplier={quantity}
                onTimesChange={handleTimesChange}
              />
            </Grid>
            <Grid item xs={4}>
              <CalculatorModal
                product={product}
                quantity={quantity}
                onSave={handleSave}
                handleClose={handleDialogClose}
              />
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </>
  );
};

export default EstimatedProductionTimesDialog;
